import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Shield } from 'lucide-react';

interface ProtectedAdminRouteProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export function ProtectedAdminRoute({ children, fallback }: ProtectedAdminRouteProps) {
  const { user } = useAuth();

  if (!user?.isAdmin) {
    // Always return the fallback if provided, or null for non-admin users
    return fallback !== undefined ? fallback : null;
  }

  return <>{children}</>;
}